"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  TOP: 'top',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM: 'bottom',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  LEFT: 'left',
  RIGHT: 'right'
};
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvc3JjL1Bvc2l0aW9uLmpzIl0sIm5hbWVzIjpbIlRPUCIsIlRPUF9MRUZUIiwiVE9QX1JJR0hUIiwiQk9UVE9NIiwiQk9UVE9NX0xFRlQiLCJCT1RUT01fUklHSFQiLCJMRUZUIiwiUklHSFQiXSwibWFwcGluZ3MiOiI7Ozs7OztlQUFlO0FBQ2JBLEVBQUFBLEdBQUcsRUFBRSxLQURRO0FBRWJDLEVBQUFBLFFBQVEsRUFBRSxVQUZHO0FBR2JDLEVBQUFBLFNBQVMsRUFBRSxXQUhFO0FBSWJDLEVBQUFBLE1BQU0sRUFBRSxRQUpLO0FBS2JDLEVBQUFBLFdBQVcsRUFBRSxhQUxBO0FBTWJDLEVBQUFBLFlBQVksRUFBRSxjQU5EO0FBT2JDLEVBQUFBLElBQUksRUFBRSxNQVBPO0FBUWJDLEVBQUFBLEtBQUssRUFBRTtBQVJNLEMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG4gIFRPUDogJ3RvcCcsXG4gIFRPUF9MRUZUOiAndG9wLWxlZnQnLFxuICBUT1BfUklHSFQ6ICd0b3AtcmlnaHQnLFxuICBCT1RUT006ICdib3R0b20nLFxuICBCT1RUT01fTEVGVDogJ2JvdHRvbS1sZWZ0JyxcbiAgQk9UVE9NX1JJR0hUOiAnYm90dG9tLXJpZ2h0JyxcbiAgTEVGVDogJ2xlZnQnLFxuICBSSUdIVDogJ3JpZ2h0J1xufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/constants/src/Position.js
// module id = 152
// module chunks = 0